import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchSessions } from "../api";
import ClientHeader from "./ClientHeader";

const formatTimestamp = (ts) => {
    if (!ts) return { day: "—", time: "" };
    const d = new Date(ts);
    const day = `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
    const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    return { day, time };
};

const SessionsPage = ({ user, onLogout }) => {
    const navigate = useNavigate();
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const loadSessions = async () => {
        setLoading(true);
        setError("");
        try {
            const data = await fetchSessions();
            const sorted = (data || []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setSessions(sorted);
        } catch (err) {
            setError(err.message || "Failed to load sessions.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadSessions(); }, []);

    return (
        <div className="sessions-page-container">
            <ClientHeader user={user} onLogout={onLogout} />
            <div className="cr-page">
            <div className="cr-page-title-row">
                <h1 className="cr-page-title">Review Sessions</h1>
            </div>

            {error && <div className="cr-alert cr-alert-error" style={{ marginBottom: 16 }}>{error}</div>}

            {loading && sessions.length === 0 ? (
                <div className="cr-loading">Loading sessions…</div>
            ) : sessions.length === 0 ? (
                <div className="cr-empty">No sessions available for your organization.</div>
            ) : (
                <div className="cr-table-container">
                    <table className="cr-table">
                        <thead>
                            <tr>
                                <th>Session Name</th>
                                <th>Created By</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sessions.map(s => {
                                const ts = formatTimestamp(s.created_at);
                                return (
                                    <tr key={s.session_id}>
                                        <td><div className="cr-session-name">{s.session_name || "Unnamed"}</div></td>
                                        <td>{s.created_by || "—"}</td>
                                        <td>
                                            <div className="cr-timestamp-day">{ts.day}</div>
                                            <div className="cr-timestamp-time">{ts.time}</div>
                                        </td>
                                        <td>
                                            <div className="cr-actions">
                                                <button className="cr-action-btn" onClick={() => navigate(`/session/${s.session_id}`)}>
                                                    👁 Open Session
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            </div>
        </div>
    );
};

export default SessionsPage;

